import { Button, Modal, Form, Select, Space } from 'antd';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useEffect, useState, useRef } from 'react';
import GlobalService from '../../../services/Global.service';
import parse from 'html-react-parser';

const ModalRelease = ({
    open,
    title,
    handelClose,
    handelClearRelease,
    loading,
    width = 135,
    releaseList
}) => {
    const [form] = Form.useForm();
    const { t } = useTranslation('landing');
    const [releaseListChange, setReleaseListChange] = useState();
    const [releaseDetail, setReleaseDetail] = useState([]);
    const contentRef = useRef(null);

    const onFinish = async (values) => {
        handelClearRelease(false);
    };
    useEffect(() => {
        if (releaseList.length > 0) {
            form.setFieldsValue({ assignee: releaseList[0]?.releaseNoteId });
            setReleaseListChange(releaseList[0]?.releaseNoteId)
        }
    }, [releaseList, form]);

    useEffect(() => {
        const getRelease = async () => {
            try {
                const { data } = await GlobalService.getReleaseDetail(releaseListChange);
                if (data?.resultData) {
                    setReleaseDetail(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        releaseListChange && getRelease();
    }, [releaseListChange]);

    function handleChange(value) {
        setReleaseListChange(value);
        // Scroll to top
        if (contentRef.current) {
            contentRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
    }
    
    return (
        <Modal
            width={455}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
            centered
        >
            <div className="flex flex-col space-y-4 justify-center items-center pt-6 text-center">
                <h1 className="text-2xl font-semibold whitespace-pre-line">
                    {title}
                </h1>
                <Form
                    form={form} layout="vertical"
                    className='w-full'
                >
                    <Form.Item
                        name="assignee"
                        label={<span className='font-semibold text-sm text-[#65707A]'>{t('Version')}</span>}
                        rules={[
                            {
                                required: true,
                                message: t('requiredField'),
                            },
                        ]}
                        className='text-left'
                    >
                        <Select
                            size="large"
                            className="w-full"
                            placeholder={t('Version')}
                            optionFilterProp="children"
                            initialValues={{
                                assignee: releaseList.length > 0 ? releaseList[0]?.releaseNoteId : undefined
                            }}
                            onChange={handleChange}
                        >
                            {releaseList.map((item) => (
                                <Select.Option
                                    key={item.releaseNoteId}
                                    value={item.releaseNoteId}
                                >
                                    {item.version}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {releaseDetail?.content &&
                        <p ref={contentRef} className='text-left h-[18rem] bg-[#F4F6FC] rounded-lg p-4 overflow-hidden overflow-y-auto'>
                            {parse(
                                `${releaseDetail?.content}`
                            )}
                        </p>
                    }
                    <Form.Item className="flex justify-center mt-6 mb-0">
                        <Space>
                            <div className="flex justify-center items-center space-x-4">
                                <>
                                    <Button
                                        style={{ width }}
                                        loading={loading}
                                        size="large"
                                        type="primary"
                                        className="w-36"
                                        onClick={onFinish}
                                    >
                                        {t('Close')}
                                    </Button>
                                </>
                            </div>
                        </Space>
                    </Form.Item>
                </Form>
            </div>

        </Modal>
    );
};
export default ModalRelease;
